const pushOrCreate = <V>(value: V, currentValue?: V[]): V[] => [
  ...(currentValue ?? []),
  value
];

/**
 * Assigns value to the accumulator object key
 *
 * WARN: To be used only inside of reduce as it mutates the accumulator value
 */
export const sortItem = <T, I>(items: T, key: keyof T, item: I): void => {
  // eslint-disable-next-line no-param-reassign
  items[key as string] = pushOrCreate(item, items[key as string]);
};
